:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobileWizard_1q5tm_7 {
  position: absolute;
  width: 100%;
  height: 100%; }
  ._mobileWizard_1q5tm_7 ._mobileWizardLeftHalf_1q5tm_11 {
    position: relative;
    transition: transform 1.7s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-100%);
    box-sizing: border-box;
    text-align: center;
    background: #fff;
    width: 50%;
    left: 0;
    top: 0;
    height: 100%;
    min-width: 640px; }
  ._mobileWizard_1q5tm_7 ._mobileWizardTopBar_1q5tm_23 {
    transition: opacity 1.7s ease-in-out;
    opacity: 0;
    width: 100%;
    height: 48px;
    position: absolute;
    top: 0;
    z-index: 1; }
    ._mobileWizard_1q5tm_7 ._mobileWizardTopBar_1q5tm_23 ._topBarLeftWixLogo_1q5tm_31 {
      border-right: none;
      position: absolute;
      left: 23px;
      top: 15px; }
    ._mobileWizard_1q5tm_7 ._mobileWizardTopBar_1q5tm_23 ._mobileWizardTopBarSkip_1q5tm_36 {
      position: absolute;
      font-size: 16px;
      top: 28px;
      right: 36px; }
  ._mobileWizard_1q5tm_7._mobileWizardExpanded_1q5tm_41 ._mobileWizardLeftHalf_1q5tm_11 {
    transform: translateX(0); }
  ._mobileWizard_1q5tm_7._mobileWizardExpanded_1q5tm_41 ._mobileWizardTopBar_1q5tm_23 {
    opacity: 1; }
  ._mobileWizard_1q5tm_7 ._mobileWizardInner_1q5tm_45 {
    top: calc( 50% - 247.5px - 36px);
    position: relative; }
    ._mobileWizard_1q5tm_7 ._mobileWizardInner_1q5tm_45::after {
      content: '';
      border-right: 1px solid #d3edff;
      position: absolute;
      width: 0;
      height: 608px;
      top: 0;
      right: 0; }
    ._mobileWizard_1q5tm_7 ._mobileWizardInner_1q5tm_45 ._currentStepContainer_1q5tm_56 {
      min-height: 400px;
      max-width: 542px;
      margin: auto;
      width: 100%;
      box-sizing: border-box;
      padding: 12px 0; }
    ._mobileWizard_1q5tm_7 ._mobileWizardInner_1q5tm_45 ._mobileWizardActions_1q5tm_63 {
      justify-content: center; }
      ._mobileWizard_1q5tm_7 ._mobileWizardInner_1q5tm_45 ._mobileWizardActions_1q5tm_63 button:first-of-type {
        margin-left: 0; }
